import React from 'react';
import ClassAssembly9C  from 'views/ClassAssembly9C';

const ClassAssembly9CPage = () => {
    return <ClassAssembly9C />;
  };
  
  export default ClassAssembly9CPage;

  //9C